import { Box, FormControl, FormLabel } from '@chakra-ui/react';
import { FormikErrors, FormikHandlers, FormikHelpers, FormikState } from 'formik';
import { FormListSelection, Text } from 'components/UI';
import { validateForm } from 'utils/helpers';
import { messageRoleAdminProductsSpecifications, messageRoleAnonymousPages } from 'constants/messages';
import { IOption } from 'types';
import { IRoleResource } from '../../../../../../server/types';

type RelationFormProps = {
  values: Partial<IRoleResource>;
  submitted: boolean;
  name: keyof IRoleResource;
  label: string;
  errors: FormikErrors<IRoleResource | Record<string, never>>;
  data?: Partial<IRoleResource>;
  onBlur: FormikHandlers['handleBlur'];
  onChange: FormikHandlers['handleChange'];
  touched: FormikState<IRoleResource | Record<string, never>>['touched'];
  setFieldValue: FormikHelpers<IRoleResource | Record<string, never>>['setFieldValue'];
  options: IOption[];
  fullAccess?: boolean;
  anonymous?: boolean;
};

const RelationForm = ({
  values,
  data,
  name,
  label,
  setFieldValue,
  onChange,
  onBlur,
  options,
  anonymous,
  fullAccess,
  ...props
}: RelationFormProps) => {
  const formErrors = validateForm<IRoleResource | Record<string, never>>(props);

  if (fullAccess) {
    return <Text>{messageRoleAdminProductsSpecifications}</Text>;
  }

  if (anonymous) {
    return <Text textAlign="center">{messageRoleAnonymousPages}</Text>;
  }

  return (
    <Box display="flex" flexDir="column" h="full">
      <FormControl isInvalid={!!formErrors[name]} mb={4}>
        <FormLabel htmlFor={name}>{label ? label.toUpperCase() : null}</FormLabel>
        <FormListSelection
          bgColor="white"
          _hover={{
            bgColor: 'white',
          }}
          _focus={{
            bgColor: 'white',
          }}
          containerProps={{
            flex: 1,
            h: 'full',
            __css: {
              'select option': {
                bgColor: 'white',
              },
            },
          }}
          resultContainerProps={{
            bg: 'white',
            flex: 1,
          }}
          name={name}
          hideOrder
          error={formErrors[name]}
          value={(values[name] as readonly string[]) ?? []}
          onChange={onChange}
          onBlur={onBlur}
          options={options}
          setFieldValue={setFieldValue}
        />
      </FormControl>
    </Box>
  );
};

export default RelationForm;
